var _defs, _path, _path2, _path3, _path4, _ellipse, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path0, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilitary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.4 10.533 60.533 60.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#26282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0a0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wd",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a6a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e3a1c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 38 L62 56 L59 60 L30 44Z",
    fill: "url(#wd)",
    stroke: "#3a2410",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34 L46 34 L48 40 L30 40Z",
    fill: "url(#wd)",
    stroke: "#3a2410",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25 Q4 21 8 21 L46 27 Q53 28 52 34 Q51 38 45 38 L8 30 Q4 29 4 25Z",
    fill: "url(#br)",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23 L44 28.5",
    stroke: "#9a9da2",
    strokeWidth: 1.2,
    opacity: 0.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 25.5,
    rx: 2.4,
    ry: 4.4,
    fill: "#1a1a1a",
    stroke: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 33,
    r: 2.6,
    fill: "#111"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 44,
    r: 15,
    fill: "none",
    stroke: "#5e3a1c",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 44,
    r: 15,
    fill: "none",
    stroke: "#a87a48",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0 44.0 L48.0 44.0",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 37.5 L46.3 50.5",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.7 L41.5 55.3",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0 31.0 L35.0 57.0",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 32.7 L28.5 55.3",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 37.5 L23.7 50.5",
    stroke: "#7a5228",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 44,
    r: 4,
    fill: "#3a2410"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 44,
    r: 1.6,
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitary);
export default __webpack_public_path__ + "static/media/military.52626955cd36e65a1f1219d55cbbff77.svg";
export { ForwardRef as ReactComponent };